import { render } from "./DetailDishItem.vue?vue&type=template&id=0fe91f26&scoped=true&ts=true"
import script from "./DetailDishItem.vue?vue&type=script&lang=ts"
export * from "./DetailDishItem.vue?vue&type=script&lang=ts"

import "./DetailDishItem.vue?vue&type=style&index=0&id=0fe91f26&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe91f26"]])

export default __exports__